import type { FavoriteVehicle } from '@carvana/merch-contracts';
import { type AxiosPromise } from 'axios';
import { httpWithAuth } from '~/clients';
import { GET_FAVORITES } from '~/constants/endpoints';

export default function fetchFavorites(
  zip5: string,
  controller?: AbortController
): AxiosPromise<FavoriteVehicle[]> {
  return httpWithAuth.get<FavoriteVehicle[]>(`${GET_FAVORITES}?zip5=${zip5}`, {
    signal: controller?.signal
  });
}
